module.exports = __webpack_public_path__ + "static/media/mascot_req1.da247f5d.png";